<!-- eslint-disable -->
<template>
  <div :class="P_customClass">
    <component :is="DV_componentType">{{P_customCss}}</component>
    <ControlProcessorNameLabel :P_cpUid="`${P_cpUid}`" :style="textStyle"></ControlProcessorNameLabel>
  </div>
</template>

<script>
/* eslint-disable */
import { bi10GridComponent } from "../../watchdog_includes/base_i10_UI_mixins"
import ControlProcessorNameLabel from "../labels/ControlProcessorNameLabel"

export default {
  props: ["P_fontSize", "P_fontWeight", "P_fontColor", "P_cpUid", 'P_customCss'],
  name: "GDeviceName",
  mixins: [bi10GridComponent],
  components: { ControlProcessorNameLabel },
  data () {
    return {}
  },
  computed: {
    textStyle() {
      let customCSS = {
        height: '100%',
        width: '100%',
        marginTop: '5px',
        marginLeft: '5px'
      }

      if (this.P_fontSize) customCSS["fontSize"] = this.P_fontSize
      if (this.P_fontWeight) customCSS["fontWeight"] = this.P_fontWeight
      if (this.P_fontColor) customCSS["color"] = this.P_fontColor
      
      return customCSS;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Grid/GDeviceName.vue